export default "__VITE_ASSET__BZWSDTnI__"